import { useState, useEffect } from 'react';
import '../About.css';
import { useLang } from '../context/LanguageContext';
import en from '../lang/en';
import de from '../lang/de';
import it from '../lang/it';
import fr from '../lang/fr';
import { aboutusVideo } from '../assets/media';


function About() {
  const { lang } = useLang();
  const slides = lang === 'de' ? de.about.slides : lang === 'it' ? it.about.slides : lang === 'fr' ? fr.about.slides : en.about.slides;
  const [current, setCurrent] = useState(0);
  const [animKey, setAnimKey] = useState(0);
  const [direction, setDirection] = useState('next');
  const [paused, setPaused] = useState(false);

  const goTo = (index) => {
    if (index === current) return;
    setDirection(index > current ? 'next' : 'prev');
    setCurrent(index);
    setAnimKey(k => k + 1);
  };

  const next = () => goTo((current + 1) % slides.length);
  const prev = () => goTo((current - 1 + slides.length) % slides.length);

  useEffect(() => {
    if (paused) return;
    const timer = setTimeout(next, 10000);
    return () => clearTimeout(timer);
  }, [current, paused]); // eslint-disable-line react-hooks/exhaustive-deps

  const slide = slides[current];

  return (
    <div className="about-page" onClick={() => setPaused(p => !p)}>
      <video ref={el => { if (el) el.playbackRate = 0.5; }} className="page-bg-video" src={aboutusVideo} autoPlay loop muted playsInline />
      <div className="page-bg-overlay"></div>
      <div className="about-slider" key={animKey} data-dir={direction}>
        {paused && <div className="about-paused-badge">⏸</div>}

        {/* Left — Quote */}
        <div className="about-image-side about-img-in">
          <div className="about-img-placeholder">
            <div className="about-placeholder-glow"></div>
            <div className="about-quote-bg-mark">"</div>
            <div className="about-number-badge">{slide.number}</div>
            <div className="about-quote">
              <p className="about-quote-text about-qtext-in">
                {slide.quoteBefore}{slide.quoteHighlight}{slide.quoteAfter}
              </p>
              <div className="about-quote-divider about-qdivider-in"></div>
              <span className="about-quote-author about-qauthor-in">{slide.quoteAuthor}</span>
            </div>
          </div>
        </div>

        {/* Right — Text */}
        <div className="about-text-side">
          <span className="about-tag about-tag-in">{slide.tag}</span>
          <h2 className="about-title about-title-in">
            {slide.titleBefore}
            <span className="about-highlight">{slide.titleHighlight}</span>
          </h2>
          <p className="about-subtitle about-subtitle-in">{slide.subtitle}</p>
          <p className="about-body about-body-in" style={{ borderLeftColor: slide.accent }}>{slide.body}</p>
          <ul className={`about-features about-features-in${slide.featureCols === 2 ? ' about-features-2col' : ''}`}>
            {slide.features.map((f, i) => (
              <li
                key={i}
                className="about-feature-item"
                style={{ animationDelay: `${0.55 + i * 0.12}s` }}
              >
                <span className="about-feature-icon">◈</span>
                {f.label}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Navigation */}
      <div className="about-nav">
        <button className="about-arrow" onClick={prev} aria-label="Previous">&#8592;</button>
        {slides.map((s, i) => (
          <button
            key={i}
            className={`about-nav-label${i === current ? ' active' : ''}`}
            onClick={() => goTo(i)}
          >
            {s.titleBefore}{s.titleHighlight}
          </button>
        ))}
        <button className="about-arrow" onClick={next} aria-label="Next">&#8594;</button>
      </div>
    </div>
  );
}

export default About;
